import React, { useEffect, useState } from "react";
import { Card, Row, Col, message, Button, Table, Spin, Typography, Modal } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined, InfoCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import ServiceForm from "./ServiceForm";
import { Link } from "react-router-dom";

const { Title } = Typography;

const ServiceList = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      setLoading(true);
      const response = await axios.get("http://93.127.203.113:5005/services");
      setServices(response.data);
    } catch (error) {
      message.error("Failed to load services.");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (record) => {
    setFormData(record);
    setModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`http://93.127.203.113:5005/services/${id}`);
      message.success("Service deleted successfully.");
      fetchServices();
    } catch (error) {
      message.error("Failed to delete service.");
    }
  };

  const columns = [
    { title: "Title", dataIndex: "title", key: "title" },
    { title: "Description", dataIndex: "description", key: "description" },

    {
      title: <span style={{ fontWeight: "bold", color: "#0c8c49" }}>Actions</span>,
      key: "actions",
      render: (_, record) => (
        <>
          {/* Edit Button */}
          <Button type="link" icon={<EditOutlined />} onClick={() => handleEdit(record)} style={{ color: "#0c8c49" }}>
            Edit
          </Button>

          {/* Details Link */}
          {/* <Link to={`/services/${record.id}`} style={{ color: "#0c8c49", marginLeft: 10 }}>
            <InfoCircleOutlined /> Details
          </Link> */}

          {/* Delete Button */}
          {/* <Button type="link" icon={<DeleteOutlined />} onClick={() => handleDelete(record.id)} danger style={{ marginLeft: 10 }}>
            Delete
          </Button> */}
        </>
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <Card style={styles.card}>
        {/* Header: Title + Add Button */}
        <Row justify="space-between" align="middle" style={{ marginBottom: "20px" }}>
          <Col>
            <Title level={4} style={{ color: "#0c8c49" }}>Services</Title>
          </Col>
          <Col>
            <Button 
              type="primary" 
              icon={<PlusOutlined />} 
              onClick={() => setModalVisible(true)} 
              style={styles.addButton}
            >
              Add Service
            </Button>
          </Col>
        </Row>

        {/* Table with Loading Spinner */}
        {loading ? <Spin size="large" /> : <Table columns={columns} dataSource={services} rowKey="id" pagination={{ pageSize: 5 }} />}
      </Card>

      {/* Service Form Modal */}
      <Modal
        title={formData ? "Edit Service" : "Add Service"}
        visible={modalVisible}
        footer={null}
        onCancel={() => {
          setModalVisible(false);
          setFormData(null);
        }}
        destroyOnClose
      >
        <ServiceForm formData={formData} setFormData={setFormData} closeModal={() => setModalVisible(false)} refetchData={fetchServices} />
      </Modal>
    </div>
  );
};

// 🎨 Styled Components
const styles = {
  card: {
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    padding: "20px",
  },
  addButton: {
    backgroundColor: "#28a745",
    borderColor: "#28a745",
    color: "#fff",
  },
};

export default ServiceList;
